import ChargerExperience from '@/components/redesign/ChargerExperience';
export default function Opladere() {
  return <ChargerExperience />;
}